export default "__VITE_ASSET__DPEPkrWl__"